var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_24002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C16.5 9.82843 15.8284 10.5 15 10.5C14.1716 10.5 13.5 9.82843 13.5 9C13.5 8.17157 14.1716 7.5 15 7.5C15.8284 7.5 16.5 8.17157 16.5 9Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C10.3431 12.75 9 14.0931 9 15.75V16.5C9 18.1569 10.3431 19.5 12 19.5C13.6569 19.5 15 18.1569 15 16.5V15.75C15 14.0931 13.6569 12.75 12 12.75Z",
    fill: "#061240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 0.75C8.3214 0.75 5.48475 1.99064 3.57257 4.06707C1.6697 6.13339 0.75 8.95333 0.75 11.9992C0.75 15.045 1.6697 17.8649 3.57257 19.9313C5.48475 22.0077 8.3214 23.2483 11.9992 23.2483C15.6769 23.2483 18.5136 22.0077 20.4258 19.9313C22.3286 17.8649 23.2483 15.045 23.2483 11.9992C23.2483 8.95333 22.3286 6.13339 20.4258 4.06707C18.5136 1.99064 15.6769 0.75 11.9992 0.75ZM2.25 11.9992C2.25 9.24647 3.07946 6.81683 4.67597 5.08319C6.26316 3.35967 8.67609 2.25 11.9992 2.25C15.3222 2.25 17.7352 3.35967 19.3224 5.08319C20.9189 6.81683 21.7483 9.24647 21.7483 11.9992C21.7483 14.7519 20.9189 17.1815 19.3224 18.9151C17.7352 20.6387 15.3222 21.7483 11.9992 21.7483C8.67609 21.7483 6.26316 20.6387 4.67597 18.9151C3.07946 17.1815 2.25 14.7519 2.25 11.9992Z",
    fill: "#061240"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_24002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurious);
export default __webpack_public_path__ + "static/media/curious.b2133381.svg";
export { ForwardRef as ReactComponent };